import { Box } from "@mui/material";
import { useState } from "react";
import { BiTrash } from "react-icons/bi";
import { BsPinAngle } from "react-icons/bs";
import { IoMdCopy } from "react-icons/io";
import { MdRemoveRedEye } from "react-icons/md";
import FdIconButton from "../UIComponents/IconButton/FdIconButton";
import { UniversalListStyle as classes } from "./style";
import FdTypography from "../UIComponents/Typography/FdTypography";
import { actionDialogType } from "../UIComponents/FdDialog";
import SimpleActionDialog from "../SimpleActionDialog/SimpleActionDialog";
import { Props as dialogType } from "./../../components/SimpleActionDialog/SimpleActionDialog";
import { dataType } from "../UniversalList/UniversalList";

export const ItemSummary = ({
  item,
  actions,
  type,
}: {
  item: any;
  type: dataType;
  actions: {
    onDelete?: Function;
    onEdit: Function;
    onDuplicate?: Function;
    setDefault?: Function;
    onCheckOut?: Function;
  };
}) => {
  const [isVisible] = useState(false);
  const [confirmationDialog, setConfirmationDialog] = useState<dialogType>({
    open: false,
    title: "",
    type: actionDialogType.REGULAR,
    isLoading: false,
    onConfirm: () => { },
  });
  // const [status] = useState<registrationStatus>(registrationStatus.ATTENDED);
  // const backColor = (statusColor: string) => {
  //   switch (statusColor) {
  //     case registrationStatus.INCOMPLETE:
  //       return "#F6A316";
  //     case registrationStatus.CONFIRMED:
  //       return "#1798e5";
  //     case registrationStatus.ATTENDED:
  //       return "#7BB225";
  //     case registrationStatus.NO_SHOW:
  //       return "#F64D16";
  //     default:
  //       return "#A8A8A8";
  //   }
  // };
  const handleDialogClose = () => {
    setConfirmationDialog({
      ...confirmationDialog,
      open: false,
    });
  };

  const showDeleteDialog = (id: number) => {
    setConfirmationDialog({
      open: true,
      title: "Are you sure you want to delete this Alert?",
      icon: <BiTrash size="45" />,
      type: actionDialogType.WARNING,
      isLoading: false,
      onConfirm: () => {
        actions.onDelete && actions.onDelete(id);
        handleDialogClose();
      },
      onCancel: handleDialogClose,
    });
  };

  return (
    <Box sx={classes.attendeeDetails} className="attendeeDetails">
      <Box flexGrow="1" display="flex" alignItems="center">
        <FdTypography
          sx={classes.attendeeName}
          component="span"
          label={item.name || item.thirdPartyId}
        />
        {/* <FdChip
          label={status}
          sx={[classes.registrationStatus, { bgcolor: backColor(status) }]}
        />
  <FdTypography mr={1} label="JobTitle" /> */}
        <FdTypography
          sx={classes.attendeeCompany}
          component="span"
          label={type === dataType.CHECKED_IN_ATTENDEE && item.company}
        />
      </Box>

      <Box sx={classes.actions}>
        {/* {actions.onEdit && (
          <FdIconButton Icon={<BiEdit title="Edit" />} onClick={() => actions.onEdit(item.id)}/>
        )} */}
        {actions.setDefault && (
          <FdIconButton Icon={<BsPinAngle title="Set Default" />} />
        )}
        {actions.onDuplicate && (
          <FdIconButton Icon={<IoMdCopy title="Duplicate" />} />
        )}
        {actions.onDelete && (
          <FdIconButton
            Icon={<BiTrash title="Delete" />}
            onClick={() => showDeleteDialog(item?.id)}
          />
        )}
        {/* {actions.onCheckOut && type === dataType.CHECKED_IN_ATTENDEE && (
          <>
            <FdButton
              sx={{ marginLeft: "10px" }}
              startIcon={<FiLogOut size="15" />}
              ButtonName="Check out"
              variant="text"
            />
          </>
        {/* HIDING THE CHECKOUT BUTTON IN CHECKED_IN_ATTENDEE AS NOT NEEDED RIGHT NOW BUT FUTURE FOR SURE */}
        {/* {actions.onCheckOut && type === dataType.CHECKED_IN_ATTENDEE && (
          <FdButton
            sx={{ marginLeft: "10px" }}
            startIcon={<FiLogOut size="15" />}
            ButtonName="Check out"
            variant="text"
          />
        )} */}

        {isVisible && (
          <FdIconButton
            sx={classes.viewIcon}
            className="viewIcon"
            Icon={<MdRemoveRedEye />}
          />
        )}
        {confirmationDialog.open && (
          <SimpleActionDialog
            type={confirmationDialog.type}
            icon={confirmationDialog.icon}
            open={confirmationDialog.open}
            title={confirmationDialog.title}
            isLoading={confirmationDialog.isLoading}
            onConfirm={confirmationDialog.onConfirm}
            onCancel={confirmationDialog.onCancel}
            onClose={handleDialogClose}
            content={confirmationDialog.content}
            confirmLabel={confirmationDialog.confirmLabel}
          />
        )}
      </Box>
    </Box>
  );
};
